"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRequestSubscriptionMutation = exports.MUTATION = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _client = require("@apollo/client");
var _useCustomMutation = require("../useCustomMutation");
var _templateObject; // Copyright © 2021 LexisNexis Risk Solutions Group
const MUTATION = exports.MUTATION = (0, _client.gql)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  mutation requestSubscription($items: [String!]!, $source: String!, $productInterest: String) {\n    requestSubscription(items: $items, source: $source, productInterest: $productInterest)\n  }\n"])));
const useRequestSubscriptionMutation = () => {
  const {
    action
  } = (0, _useCustomMutation.useCustomMutation)(MUTATION);
  return {
    action
  };
};
exports.useRequestSubscriptionMutation = useRequestSubscriptionMutation;